import { createSlice } from "@reduxjs/toolkit"
import { bookingDummyData } from "components/Common/constants"
import {
  getAllBookings,
  getBookingDetails,
  updateBookingStatus,
  uploadContract,
  uploadDeedDocuments,
  uploadDeliveryLetter,
} from "store/actions/bookingAction"

const initialState = {
  loading: null,
  isLoading: null,
  bookingsList: [],
  bookingDetails: {},
  isDetailsLoading: false,
  totalCount: null,
  totalPages: null,
  currentPage: null,
}

const usersSlice = createSlice({
  name: "Bookings",
  initialState,
  reducers: {},
  extraReducers: builder => {
    // GET ALL LIST
    builder
      .addCase(getAllBookings.pending, state => {
        state.loading = true
        state.bookingsList = []
        state.totalCount = null
        state.totalPages = null
        state.currentPage = null
      })
      .addCase(getAllBookings.fulfilled, (state, action) => {
        state.loading = false
        const { success, statusCode } = action.payload
        if (success && statusCode === 200) {
          const { data, totalCount, totalPages, currentPage, totalRecords } =
            action.payload
          state.bookingsList = data
          state.totalPages = totalPages
          state.currentPage = currentPage
        }
      })
      .addCase(getAllBookings.rejected, (state, action) => {
        state.loading = false
      })

    // BOOKING DETAILS
    builder
      .addCase(getBookingDetails.pending, state => {
        state.isDetailsLoading = true
        state.bookingDetails = {}
      })
      .addCase(getBookingDetails.fulfilled, (state, action) => {
        state.isDetailsLoading = false
        const { success, statusCode, data } = action.payload
        if (success && statusCode === 200) {
          state.bookingDetails = data
        }
      })
      .addCase(getBookingDetails.rejected, (state, action) => {
        state.isDetailsLoading = false
      })

    //   UPDATE BOOKING STATUS
    builder
      .addCase(updateBookingStatus.pending, state => {
        state.isLoading = true
      })
      .addCase(updateBookingStatus.fulfilled, (state, action) => {
        state.isLoading = false
        const { success, statusCode, data } = action.payload
        if (success && statusCode === 200) {
          const { bookingId } = action.meta.arg
          // UPDATE REQ BOOKING
          state.bookingsList = state.bookingsList.map(item =>
            item._id === bookingId ? data : item
          )
          // UPDATE BOOKING STATUS
          state.bookingDetails = data
        }
      })
      .addCase(updateBookingStatus.rejected, (state, action) => {
        state.isLoading = false
      })

    // UPLOAD CONTRACT
    builder
      .addCase(uploadContract.pending, state => {
        state.isLoading = true
      })
      .addCase(uploadContract.fulfilled, (state, action) => {
        state.isLoading = false
        const { response, bookingId } = action.payload
        const { success, statusCode, data } = response
        if (success && statusCode === 200) {
          // UPDATE REQ BOOKING
          state.bookingsList = state.bookingsList.map(item =>
            item._id === bookingId ? data : item
          )
          // UPDATE BOOKING STATUS
          state.bookingDetails = data
        }
      })
      .addCase(uploadContract.rejected, (state, action) => {
        state.isLoading = false
      })

    // UPLOAD DELIVERY LETTER
    builder
      .addCase(uploadDeliveryLetter.pending, state => {
        state.isLoading = true
      })
      .addCase(uploadDeliveryLetter.fulfilled, (state, action) => {
        state.isLoading = false
        const { response, bookingId } = action.payload
        const { success, statusCode, data } = response
        if (success && statusCode === 200) {
          // UPDATE REQ BOOKING
          state.bookingsList = state.bookingsList.map(item =>
            item._id === bookingId ? data : item
          )
          // UPDATE BOOKING STATUS
          state.bookingDetails = data
        }
      })
      .addCase(uploadDeliveryLetter.rejected, (state, action) => {
        state.isLoading = false
      })

    // UPLOAD Deed
    builder
      .addCase(uploadDeedDocuments.pending, state => {
        state.isLoading = true
      })
      .addCase(uploadDeedDocuments.fulfilled, (state, action) => {
        state.isLoading = false
        const { response, bookingId } = action.payload
        const { success, statusCode, data } = response
        if (success && statusCode === 200) {
          // UPDATE REQ BOOKING
          state.bookingsList = state.bookingsList.map(item =>
            item._id === bookingId ? data : item
          )
          // UPDATE BOOKING STATUS
          state.bookingDetails = data
        }
      })
      .addCase(uploadDeedDocuments.rejected, (state, action) => {
        state.isLoading = false
      })
  },
})

export default usersSlice.reducer
